import {
  ProductCategory,
  ProductTypeLabel,
} from 'src/modules/designStudio/helpers/productSelection/types';

export const ProductTypeNames: Record<ProductTypeLabel, string> = {
  [ProductTypeLabel.HORIZONTAL_SIDING]: 'Horizontal',
  [ProductTypeLabel.VERTICAL_SIDING]: 'Vertical',
  [ProductTypeLabel.SHINGLED_SIDING]: 'Shingles',
  [ProductTypeLabel.BRICK_SIDING]: 'Brick',
  [ProductTypeLabel.STONE_SIDING]: 'Stone',
  [ProductTypeLabel.CONCRETE_SIDING]: 'Concrete',
  [ProductTypeLabel.STUCCO_SIDING]: 'Stucco',
  [ProductTypeLabel.SHINGLE_ROOF]: 'Shingle',
  [ProductTypeLabel.TILE_ROOF]: 'Tile',
  [ProductTypeLabel.METAL_ROOF]: 'Metal',
  [ProductTypeLabel.TRIM]: 'Trim',
};

export const ProductTypesByCategory: Record<
  ProductCategory,
  ProductTypeLabel[]
> = {
  [ProductCategory.WALLS]: [
    ProductTypeLabel.HORIZONTAL_SIDING,
    ProductTypeLabel.VERTICAL_SIDING,
    ProductTypeLabel.SHINGLED_SIDING,
    ProductTypeLabel.BRICK_SIDING,
    ProductTypeLabel.STONE_SIDING,
    ProductTypeLabel.CONCRETE_SIDING,
    ProductTypeLabel.STUCCO_SIDING,
  ],
  [ProductCategory.ROOF]: [
    ProductTypeLabel.SHINGLE_ROOF,
    ProductTypeLabel.TILE_ROOF,
    ProductTypeLabel.METAL_ROOF,
  ],
  [ProductCategory.TRIM]: [ProductTypeLabel.TRIM],
};
